import React from 'react';
import {
  Button,
  Column,
  FlexBox,
  GridContainer,
  Row,
  Typography,
} from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import useIdentityContext from '../../hooks/useIdentityContext';
import useSiteData from '../../hooks/useSiteData';
import { trackAnonymousShopperSignedIn } from '../../apis/trackingApi';

/**
 * If user is anonymous (and the site allows them), offer a prompt to sign into account.
 */
export const AccountSignInPrompt = () => {
  const { auth, identity } = useIdentityContext();
  const { isAnonymousUser, shopperId } = identity;
  const { allowAnonymousSessions } = useSiteData();
  const [signInMessages] = useTranslations(['signInMessages']);
  if (!isAnonymousUser || !allowAnonymousSessions) {
    return null;
  }

  const doSignIn = () => {
    auth.signIn();
    trackAnonymousShopperSignedIn(shopperId);
  };

  return (
    <GridContainer>
      <Row>
        <Column span={7} push={2}>
          <FlexBox
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            pt={5}
            gap={7}
          >
            <Typography fontSize="large" fontWeight="bold">
              {signInMessages.returningCustomer}
            </Typography>
            <Typography>{signInMessages.checkStatus}</Typography>
            <Button
              onClick={doSignIn}
              skin="primary"
              width="full-width"
              data-testid="anon-od-sign-in-link"
            >
              {signInMessages.signIn}
            </Button>
          </FlexBox>
        </Column>
      </Row>
    </GridContainer>
  );
};
